import {
  Badge,
  Card,
  CardContent,
  CardHeader,
  CardTitle,
} from "@exhousing/design-system";

import { useUsage } from "@/hooks/api/useBilling";

function UsageBar({
  label,
  used,
  max,
}: {
  label: string;
  used: number;
  max: number | null;
}) {
  const pct = max ? Math.min(100, Math.round((used / max) * 100)) : 0;
  const near = max !== null && used / max >= 0.8;
  return (
    <div>
      <div className="flex items-center justify-between text-sm">
        <span className="text-muted-foreground">{label}</span>
        <span className="tabular-nums">
          {used}
          {max === null ? "" : ` / ${max}`}
        </span>
      </div>
      <div className="mt-1.5 h-1.5 w-full overflow-hidden rounded-full bg-muted">
        <div
          className={`h-full rounded-full ${near ? "bg-warning" : "bg-primary"}`}
          style={{ width: max === null ? "12%" : `${pct}%` }}
        />
      </div>
    </div>
  );
}

export function PlanUsageCard({
  organizationId,
}: {
  organizationId: string | null | undefined;
}) {
  const { data } = useUsage(organizationId);
  if (!data) return null;

  return (
    <Card>
      <CardHeader className="flex-row items-center justify-between space-y-0">
        <CardTitle>Plan &amp; usage</CardTitle>
        <Badge tone="brand">{data.plan_name}</Badge>
      </CardHeader>
      <CardContent className="grid grid-cols-1 gap-4 sm:grid-cols-2">
        <UsageBar
          label="Team members"
          used={data.usage.users}
          max={data.limits.max_users}
        />
        <UsageBar
          label="Published listings"
          used={data.usage.published_listings}
          max={data.limits.max_published_listings}
        />
      </CardContent>
    </Card>
  );
}
